import { System } from '../../_snowpack/pkg/eaciest.js';
import { Vector3 } from '../../_snowpack/pkg/three.js';

const t = new Vector3;

export class MoveSystem extends System {
  constructor () {
    super(['pos', 'dir']);
  }

  update (dt) {
    for (const entity of this.getEntities()) {
      if (entity.rooted) continue;
      const speed = entity.speed ?? 1;

      Object.assign(t, entity.dir);
      t.multiplyScalar(dt * speed);

      entity.pos.add(t);
    }
  }
}
